import { useSelectionOnRow, useSelectionState } from '../../features/items/state/selection.state';

import { IndeterminateCheckbox } from './IndeterminateCheckbox';
import { Item } from '../../features/items/types/item.types';
import { Row } from '@tanstack/react-table';

export const RowCheckbox = ({ row }: { row: Row<Item> }) => {
   const { isAnySelectedOnRow, isAllSelectedOnRow, selectAllOnRow } = useSelectionOnRow(row.index);

   const [enforcedSelection] = useSelectionState((state) => [state.enforcedSelections]);

   return (
      <>
         {row.original?.subItems.length > 0 && <IndeterminateCheckbox
            {...{
               disabled: row.original?.subItems.length === 0 || row.original.deleted,
               checked: isAllSelectedOnRow,
               indeterminate: isAnySelectedOnRow,
               onChange: () => selectAllOnRow(),
            }}
         />}
         {row.original?.subItems.length === 0 && <IndeterminateCheckbox
            {...{
               disabled: false,
               checked: enforcedSelection[row.index],
               onChange: () => {
                  let arr = structuredClone(enforcedSelection);
                  arr[row.index] = !enforcedSelection[row.index];
                  useSelectionState.setState({ enforcedSelections: arr })
               },
            }}
         />}
      </>
   );
};
